import type { TranslationTag } from '@ps/web-shared-components';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { styles as sharedStyles } from '@swf/account';

interface Props {
  title: TranslationTag;
}

const InfoBlock: React.FC<React.PropsWithChildren<Props>> = ({ title, children }) => (
  <div className={sharedStyles.infoMessage}>
    <Translation tagName="b" {...title} />
    {children}
  </div>
);

export default InfoBlock;
